import axios from 'axios';

const config = require('../config.json');

export const placeOrder = (token, subtotal) => async (dispatch, getState) => {
  dispatch({ type: 'PLACE_ORDER_REQUEST' });
  const currentUser = getState().loginUserReducer.currentUser;
  const cartItems = getState().cartReducer.cartItems;
  console.log('payment started');
  console.log(cartItems);
  console.log(currentUser);
  try {
    console.log('payment started 1');
    const response = await axios.post(`${config.HOST}/api/orders/placeorder`, {
      token,
      subtotal,
      currentUser,
      cartItems,
    });
    dispatch({ type: 'PLACE_ORDER_SUCCESS' });
    console.log(response);
  } catch (error) {
    dispatch({ type: 'PLACE_ORDER_FAILED' });
    console.log(error);
  }
};

export const getUserOrders = () => async (dispatch, getState) => {
  const currentUser = getState().loginUserReducer.currentUser;
  dispatch({ type: 'GET_USER_ORDERS_REQUEST' });

  try {
    const response = await axios.post(
      `${config.HOST}/api/orders/getuserorders`,
      { userid: currentUser._id }
    );

    console.log(response);

    dispatch({ type: 'GET_USER_ORDERS_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'GET_USER_ORDERS_FAILED', payload: error });
  }
};

export const getAllOrders = () => async (dispatch, getState) => {
  const currentUser = getState().loginUserReducer.currentUser;
  dispatch({ type: 'GET_ALLORDERS_REQUEST' });

  try {
    const response = await axios.get(`${config.HOST}/api/orders/getallorders`);

    console.log(response);

    dispatch({ type: 'GET_ALLORDERS_SUCCESS', payload: response.data });
  } catch (error) {
    dispatch({ type: 'GET_ALLORDERS_FAILED', payload: error });
  }
};

export const deliverOrder = (orderid) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${config.HOST}/api/orders/deliverorder`,
      { orderid }
    );
    console.log(response);
    alert('Order Delivered');
    const orders = await axios.get(`${config.HOST}/api/orders/getallorders`);
    dispatch({ type: 'GET_ALLORDERS_SUCCESS', payload: orders.data });
  } catch (error) {
    console.log(error);
  }
};
